<template>
  <div class="video-box w-100 vh-100 position-fixed overflow-hidden">
    <video class="bg-video w-100 h-100 position-relative" autoplay muted loop playsinline preload="auto" 
      x5-video-player-type="h5" x5-video-player-fullscreen="false" x5-video-orientation="portraint" webkit-playsinline="true" 
      src="../assets/videos/intro.mp4" poster="../assets/images/video_poster.jpg" type="video/mp4">
    </video>
  </div>
  <div class="halo-world-container font-supersonic position-relative pb-5 text-white">
    <div class="container-xl pt-4">
      <div class="text-end">
        <div v-if="walletState.address" class="wallet-box position-relative mt-1 mb-1 d-inline-block text-start">
          <button class="btn btn-light pb-2 font-supersonic" @click="() => walletState.showDropdown = !walletState.showDropdown">
            {{ walletState.address.substr(0, 5) + '...' + walletState.address.substr(walletState.address.length - 4, 4) }}
            <svg class="icon align-middle ms-2" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" height="18"><path d="M163.446 275.692h697.108c19.692 0 33.477 25.6 17.723 43.323L537.6 736.492c-11.815 15.754-37.415 15.754-49.23 0L143.753 319.015c-13.785-17.723-1.97-43.323 19.692-43.323z" fill="#111111"></path></svg>
          </button>
          <button v-show="walletState.showDropdown" class="disconnect-btn btn btn-light pb-2 position-absolute w-100 font-supersonic" @click="handleDisconnect">Disconnect</button>
        </div>
        <button v-else class="connect-btn btn-light btn pb-2 mt-1 mb-1 font-supersonic" @click="handleConnect">
          CONNECT
        </button>
      </div>
      <div class="text-center fs-1" style="line-height:2rem;">CONTRACT UPGRADE CAMPAIGN</div>
      <div class="row">
        <div class="col-lg-9 mx-auto">
          <div class="row mt-5 pt-3 justify-content-between">
            <div v-for="(item, i) in collState.list" class="col-lg-5 mb-5">
              <div class="row">
                <div class="col-lg-8 mx-auto">
                  <div class="collection-img-box w-100 bg-white">
                    <img class="w-100 position-relative" :src="item.img" />
                  </div>
                  <div class="text-center mt-3 mb-4 fs-4">{{item.name}}<br />Collection</div>
                  <button v-if="!walletState.address" class="btn btn-common w-100 font-supersonic" @click="handleConnect">UPGRADE</button>
                  <button v-else-if="collState.listLoading" class="btn btn-common w-100 font-supersonic">
                    <span class="spinner-border spinner-border-sm me-2 align-middle"></span>
                    UPGRADE
                  </button>
                  <button v-else-if="item.avatarList.length" class="btn btn-common w-100 font-supersonic" @click="handleShowExchangeModal(item)">UPGRADE</button>
                  <button v-else class="btn btn-common w-100 font-supersonic" disabled>UPGRADE</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <vue-final-modal v-model="exhcangeState.showModal" classes="modal-container" content-class="modal-content w-80">
    <div v-if="exhcangeState.curItem" class="bg-white">
      <div class="p-3 bg-light d-flex justify-content-between align-items-center">
        <div class="fs-4 font-supersonic">{{exhcangeState.curItem.name}} Collection</div>
        <button class="btn btn-common font-supersonic" @click="handleExchange">
          <span v-if="exhcangeState.exchangeLoading" class="spinner-border spinner-border-sm me-2"></span>
          UPGRADE
        </button>
      </div>
      <div class="exchange-content-box p-3">
        <div class="row">
          <div v-for="item in exhcangeState.curItem.avatarList" class="col-lg-2 mb-2">
            <div class="p-3">
              <img class="w-100" :src="item.image" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </vue-final-modal>
  <vue-final-modal v-model="exhcangeState.showSuccessModal" classes="modal-container" content-class="modal-content w-40">
    <div class="bg-white font-supersonic text-center pt-5 pb-5">
      <div class="fs-3 mt-3">Congratulations!</div>
      <div class="fs-5 mt-3">The contract upgrade is completed!</div>
      <div class="mt-5 pt-3">
        <a class="btn btn-common fs-5 font-supersonic" target="_blank" href="https://market.lifeform.cc/profile">View in my NFT</a>
      </div>
    </div>
  </vue-final-modal>
</template>

<script>
import { getCurrentInstance, onMounted, ref, reactive, watch } from "vue";
import { useToast } from "vue-toastification";

import { exchangeLogin } from '../services/helpers/exchangeLogin';
import { getNftList } from '../services/api/nft';
import { getLiveConfig } from '../services/api/haloWorld';
import { getWeb3, checkERC721Allowance, approveERC721 } from '../services/helpers/utils';
import chainApi from '../services/blockchain/ChainApi.js';
import HaloNFTABI from '../services/blockchain/abi/HaloNFT.json';
import HMABI from '../services/blockchain/abi/HaloNftMapping.json'

export default {
  name: 'HALO Exchange',

  setup() {
    const { proxy } = getCurrentInstance();
    const _global = proxy._global;

    const toast = useToast();

    const walletState = reactive({
      loginLoading: false,
      address: '',
      showDropdown: false,
    });

    const collState = reactive({
      list: [
        /*
        {
          name: 'HALO NFT',
          img: require('../assets/images/collection/halo_nft.png'),
          contract: chainApi.getContractAddr('haloNft'),
          avatarList: []
        },
        */
        {
          key: 'haloAvatar',
          name: 'HALO AVATAR',
          img: require('../assets/images/collection/halo_avatar.png'),
          contract: chainApi.getContractAddr('haloAvatar'),
          avatarList: []
        },
        {
          key: 'originesCitizen',
          name: 'Origines Citizen',
          img: require('../assets/images/collection/origines_citizen.png'),
          contract: chainApi.getContractAddr('originesCitizen'),
          avatarList: []
        }
      ],
      listLoading: true,
    });

    const exhcangeState = reactive({
      curItem: null,
      showModal: false,
      showSuccessModal: false,
      exchangeLoading: false,
      blackList: {},
    })

    const handleConnect = async() => {
      console.log('connect')
      if(walletState.loginLoading) {
        return;
      }
      walletState.loginLoading = true;

      let loginRes = await exchangeLogin();
      if(loginRes && loginRes.address) {
        sessionStorage.setItem('haloWorldAccount', loginRes.address);
        walletState.address = loginRes.address;

        chainApi.ethereum.on('chainChanged', handleChainChange)
        chainApi.ethereum.on('accountsChanged', handleAccountsChanged)

        getUserData();
      }

      walletState.loginLoading = false;
    }

    const handleChainChange = (cid) => {
      if(cid == 1) {

      }
      else {

      }
    }

    const handleAccountsChanged = async() => {
      await handleDisconnect();
      handleConnect();
    }

    const handleDisconnect = async() => {
      walletState.address = null;
      walletState.showDropdown = false;
      sessionStorage.removeItem('haloWorldAccount');

      localStorage.removeItem("walletconnect");

      await chainApi.disconnect();
    }

    const getUserData = async() => {
      collState.listLoading = true;

      await getLiveConfig()
      .then(res => {
        let data = res.data;
        if(data.status == 10000) {
          exhcangeState.blackList = data.result.blackList;
        }
      })

      let temp = JSON.parse(JSON.stringify(collState.list));

      await Promise.all(
        temp.map((ele, i) => {
          ele.avatarList = [];
          return new Promise(async (resolve, reject) => {
            /*
            if(i == 0) {
              let web3 = getWeb3();
              const contract = new web3.eth.Contract(HaloNFTABI, ele.contract);
              let tokens = await contract.methods.listMyNFT(sessionStorage.getItem('haloWorldAccount')).call();

              if(tokens && tokens.length) {
                let tempHaloNftList = [];
                let cid = chainApi.getNetworkVersion();
                let img_type = _global.APP_IMG_TYPE[cid] ? _global.APP_IMG_TYPE[cid] : _global.APP_IMG_TYPE[1];
                tokens.forEach(tempTokenId => {
                  tempHaloNftList.push({
                    image: ((_global.APP_IMG_URL[cid] ? _global.APP_IMG_URL[cid] : _global.APP_IMG_URL[1]) + '/' + tempTokenId + '.' + img_type),
                    token_id: tempTokenId,
                  })
                });

                ele.avatarList = tempHaloNftList;
              }
            }
            else {
              await getNftList({
                chain_id: chainApi.getNetworkVersion(),
                page: 0,
                size: 200,
                contract: ele.contract,
                address: sessionStorage.getItem('haloWorldAccount'),
              })
              .then(res => {
                let data = res.data;
                if(data.code == 0 && data.data.items.length) {
                  ele.avatarList = data.data.items;
                }
              });
            }
            */

            await getNftList({
              chain_id: chainApi.getNetworkVersion(),
              page: 0,
              size: 200,
              contract: ele.contract,
              address: sessionStorage.getItem('haloWorldAccount'),
            })
            .then(res => {
              let data = res.data;
              if(data.code == 0 && data.data.items.length) {
                let temp = [];
                data.data.items.forEach(tempNft => {
                  if(!exhcangeState.blackList[ele.contract] || exhcangeState.blackList[ele.contract].indexOf(Number(tempNft.token_id)) == -1) {
                    temp.push(tempNft)
                  }
                });
                ele.avatarList = temp;
              }
            });
            
            resolve();
          })
        })
      )

      collState.list = temp;

      collState.listLoading = false;
    }

    const handleShowExchangeModal = (item) => {
      exhcangeState.curItem = item;
      exhcangeState.showModal = true;
    }

    const handleExchange = async() => {
      exhcangeState.exchangeLoading = true;

      let web3 = getWeb3();
      let contractAddr = chainApi.getContractAddr('haloNftMapping');
      if(exhcangeState.curItem.key == 'haloAvatar') {
        contractAddr = chainApi.getContractAddr('haloNftMapping2');
      }

      console.log(contractAddr);

      const contract = new web3.eth.Contract(HMABI, contractAddr);

      let toastIns = null;
      let nftAllowance = await checkERC721Allowance(sessionStorage.getItem('haloWorldAccount'), exhcangeState.curItem.contract, contractAddr);

      if (!nftAllowance) {
        toastIns = toast.info('Please Approve Your NFT to Exchange', { timeout: 20000 });
        
        let approveRes = await approveERC721(sessionStorage.getItem('haloWorldAccount'), exhcangeState.curItem.contract, contractAddr);
        
        if(approveRes) {
          nftAllowance = true;
        }
        toast.dismiss(toastIns);
      }

      if(nftAllowance) {
        let gas = 0;
        let tokensArr = [];
        exhcangeState.curItem.avatarList.forEach(ele => {
          tokensArr.push(ele.token_id);
        });

        if(exhcangeState.curItem.key == 'haloAvatar') {
          try {
            gas = await chainApi.getGasLimit({
              to: contractAddr,
              data: contract.methods.mappingAvatar721(exhcangeState.curItem.contract, tokensArr).encodeABI(),
              value: '0x0',
              from: sessionStorage.getItem('haloWorldAccount')
            });
          }
          catch{}

          if(gas == 0) {
            exhcangeState.exchangeLoading = false;
            toast.error('Exchange Failed, Please Try Later[Internal JSON-RPC error]', {timeout: 3000});
            return;
          }

          await contract.methods.mappingAvatar721(exhcangeState.curItem.contract, tokensArr).send({
            from: sessionStorage.getItem('haloWorldAccount'),
            gas: gas,
          })
          .then(res => {
            exhcangeState.showModal = false;
            exhcangeState.showSuccessModal = true;
            getUserData();
            setTimeout(() => {
              getUserData();
            }, 10000);
          })
          .catch(err => {
            console.log(err);
            toast.error(err.message ? err.message : err, { timeout: 3000 });
          });

        }
        else {
          try {
            gas = await chainApi.getGasLimit({
              to: contractAddr,
              data: contract.methods.mapping721(exhcangeState.curItem.contract, tokensArr).encodeABI(),
              value: '0x0',
              from: sessionStorage.getItem('haloWorldAccount')
            });
          }
          catch{}

          if(gas == 0) {
            exhcangeState.exchangeLoading = false;
            toast.error('Exchange Failed, Please Try Later[Internal JSON-RPC error]', {timeout: 3000});
            return;
          }

          await contract.methods.mapping721(exhcangeState.curItem.contract, tokensArr).send({
            from: sessionStorage.getItem('haloWorldAccount'),
            gas: gas,
          })
          .then(res => {
            exhcangeState.showModal = false;
            exhcangeState.showSuccessModal = true;
            getUserData();
            setTimeout(() => {
              getUserData();
            }, 10000);
          })
          .catch(err => {
            console.log(err);
            toast.error(err.message ? err.message : err, { timeout: 3000 });
          });
        }
      }
      else {
        toast.error('Exchange Failed, Please Try Later', {timeout: 3000});
      }

      exhcangeState.exchangeLoading = false;
    }

    onMounted(() => {
      if(sessionStorage.getItem('haloWorldAccount')) {
        handleConnect();
      }

      
    })

    return {
      walletState,
      collState,
      exhcangeState,
      handleConnect,
      handleDisconnect,
      handleShowExchangeModal,
      handleExchange,
    }
  }
}
</script>

<style scoped>
.btn-common {
  background: #7351C1;
  color: #fff;
  padding-top: 0.25rem;
  padding-bottom: 0.5rem;
  border-radius: 0;
}

.btn-common:hover {
  background: #7959c3;
}

.video-box {
  top: 0;
  left: 0;
  z-index: 0;
  background: #000;
}

.bg-video {
  object-fit: cover;
  opacity: 0.5;
  width: 135%;
  left: -17.5%;
}

.halo-world-container {
  z-index: 1;
  height: calc(100vh - 80px);
}

.connect-btn img {
  width: 26px;
}

.disconnect-btn {
  top: 3rem;
  left: 0;
}

.exchange-content-box {
  max-height: 60vh;
  overflow-y: auto;
}

.collection-img-box img {
  top: -2px;
  left: -2px;
}

@media (max-width: 992px) {
  .bg-video {
    width: 100%;
    left: 0;
  }
}
</style>

<style>
.web3modal-modal-lightbox {
  z-index: 5 !important;
}
</style>